


































import { Component, Emit, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { casePriority } from '@/modules/Newcase/helpers/case'
import { Case } from '@/modules/Newcase/interfaces/case'
import { showErrors } from '@/utils/snack'
import { dateTimeToDisplay, dateToDisplay, dateToNow } from '@/utils/dateTime'

import CaseDialog from '@/modules/Newcase/scripts/case-dialog'
import { updateCaseStep } from '@/modules/Newcase/gql/case.gql'
import CaseFoldingCard from '@/modules/Newcase/components/CaseFoldingCard.vue'

import dollarFilter from '@/utils/dollarFilter'
import AccountAssets from '@/modules/Newcase/components/AccountAssets.vue'
import AccountCertificates from '@/modules/Newcase/components/AccountCertificates.vue'
import CaseAttachmentsCard from '../components/CaseAttachmentCard.vue'
import AccountInfo from '@/modules/Newcase/components/AccountInfo.vue'
import CasePanel from '@/modules/Newcase/components/CasePanel.vue'

@Component({
  components: {
    CaseFoldingCard,
    AccountAssets,
    AccountCertificates,
    CaseAttachmentsCard,
    AccountInfo,
    CasePanel
  }
})
export default class CaseDetailInquiry extends mixins(CaseDialog) {
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case

  completeDialog = {
    show: false
  }

  propertyId = -1

  dollarFilter = dollarFilter
  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay
  dateToNow = dateToNow
  casePriority = casePriority

  get attachmentList () {
    if (!this.caseInfo) {
      return []
    }
    return this.caseInfo.account.attachments || []
  }

  toNextStep () {
    this.completeDialog.show = true
  }

  async completeStepConfirm () {
    if (!this.caseInfo) {
      return
    }
    try {
      const result = await this.$apollo.mutate({
        mutation: updateCaseStep,
        variables: {
          caseId: Number(this.caseInfo.id),
          step: this.caseInfo.step + 1
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.completeDialog.show = false
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  toPreviousStep () {

  }

  @Emit('refresh')
  onSuccess () {
    // do nothing
  }

  @Emit('assetCreate')
  onAssetCreate () {
    this.onSuccess()
  }
}
